import React from 'react';
import Icon, { IconProps } from './Icon';

/**
 * Volume X icon for audio/sound muted
 */
export const VolumeXIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
      <line x1="23" y1="9" x2="17" y2="15"></line>
      <line x1="17" y1="9" x2="23" y2="15"></line>
    </Icon>
  );
};

export default VolumeXIcon;
